export default __webpack_public_path__ + "static/media/Elena-E1A-Chip.25334b29.pdf";